<div class="searchForm flex-row" #myForm id="formMinAnnonce">
  <div class="flex-row">
    <div class="form-row">
      <div class="col-md-6 col-6">
        <label class="sr-only" for="text" >Rechercher</label>
        <input type="text" [(ngModel)]="searchText" class="form-control mb-2" id="text" placeholder="Rehercher ">
      </div>
      <div class="col-md-3 col-6">
          <ng-select class="mb-2" [ngModelOptions]="{standalone: true}"
          dropdownPosition='bottom' placeholder="Type De Place"
           [items]="placeTypes" [multiple]="true"
            [bindLabel]="'name'"
           [closeOnSelect]="false" bindValue="name" [(ngModel)]="selectedPlaceTypes"
           name="selectRegion">
          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/> {{item.name}}
          </ng-template>
         </ng-select>
      </div>
      <div class="col-md-3 col-6">
        <ng-select class="mb-2" [ngModelOptions]="{standalone: true}"
        dropdownPosition='bottom' placeholder="Zone"
         [items]="zones" [multiple]="true"
          [bindLabel]="'label'"
         [closeOnSelect]="false" bindValue="id" [(ngModel)]="selectedZone"
         name="selectedZone">
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/> {{item.label}}
        </ng-template>
       </ng-select>
    </div>
    </div>
  <div class="form-row">
    <div class="col-auto col-md-3 col-sm-3 onlyforNonMobile">
          <button type="button" (click)="creer()"
        class="btn btn-indigo btn-sm btn-block" [title]="'Creer une Configuration'"
        style= "margin-left: 0px;margin-right: 0px;width: 100%;min-width: none;"
        >Creer</button>
    </div>
    <div class="col-md-3 col-6">
        <button type="button" (click)="rechercher()"
        class="btn btn-indigo btn-sm btn-block"
        style= "margin-left: 0px;margin-right: 0px;width: 100%;min-width: none;"
        >Rechercher</button>
    </div>

   </div>
  </div>
</div>
